// --------------------------------------- Project List
export const ProjectList = [
  {
    img: "https://raw.githubusercontent.com/JohnM-Kahura/Kenyan-Eye-Blog/master/kenyan-eye.png",
    title: "Kenyan Eye",
    description: "Kenyan Eye is a blog where people can share their views on the political situation in my country",
    tech_stack: "Python,Django,Tailwind,JavaScript",
    github_url: "https://github.com/JohnM-Kahura/Kenyan-Eye-Blog",
    demo_url: "http://kenyan-eye.herokuapp.com",
  },
  {
    img: "https://raw.githubusercontent.com/JohnM-Kahura/quickbite/master/images/logo.webp",
    title: "Quick Bite",
    description: "This is a food ordering app that students use to order Burgers and Kebabs.Users can pay using MPESA.",
    tech_stack: "Flutter,Javascript,Firebase,Daraja API",
    github_url: "https://github.com/JohnM-Kahura/quickbite/tree/master",
    demo_url: "https://github.com/JohnM-Kahura/quickbite/tree/master#readme",
  },
  {
    img: "https://github.com/JohnM-Kahura/Biometrics-SPM/blob/master/alter-tech-demo.png?raw=true",
    title: "BioMetrics App",
    description:
      "This a desktop and Web app that is used to enroll students to ZKTeco biometrics Device.",
    tech_stack: "Django, Django Rest Framework, Flutter,Postgres",
    github_url: "https://github.com/JohnM-Kahura/Biometrics-SPM",
    demo_url: "https://johnm-kahura.github.io",
  },
  {
    img: "https://github.com/JohnM-Kahura/Portfolio-Redesign/blob/master/src/Assets/portfolio.jpg?raw=true",
    title: "Portfolio",
    description: "This is my portfolio",
    tech_stack: "Reactjs, Css",
    github_url: "https://github.com/JohnM-Kahura/Portfolio-Redesign",
    demo_url: "https://john-mungai.netlify.app",
  },
  {
    img: "https://github.com/JohnM-Kahura/Quiz-App/blob/master/screenshots/quiz.png?raw=true",
    title: "Quiz App",
    description: "This is a mobile app that pull questions from the trivia API and displays them tp the user.",
    tech_stack: "Flutter,Trivia API",
    github_url: "https://github.com/JohnM-Kahura/Quiz-App",
    demo_url: "https://github.com/JohnM-Kahura/Quiz-App#readme",
  },
  
  {
    img: "https://cdn.educba.com/academy/wp-content/uploads/2019/12/RSA-Algorithm.jpg",
    title: "RSA Encryptor",
    description: "This is a static page that  helps users encrypt or decrypt any text",
    tech_stack: "HTML,CSS,BootStrap,Py-Script",
    github_url: "https://github.com/JohnM-Kahura/RSA",
    demo_url: "https://github.com/JohnM-Kahura/RSA",
  },
  {
    img: "https://eac.int/images/Press_Releases/corona.jpg",
    title: "Covid Stats App",
    description: "This is a mobile app that shows users the current covid stats for each country",
    tech_stack: "Flutter",
    
    github_url: "https://github.com/JohnM-Kahura/Covid-Stats",
    demo_url: "https://github.com/JohnM-Kahura/Covid-Stats#readme",
  },
  {
    img: "https://github.com/JohnM-Kahura/Digital-Receipts/blob/master/screenshots/banner.jpg?raw=true",
    title: "Digital Receipts App",
    description: "This is a mobile app that help users share the prices of goods they buy at a gives store..",
    tech_stack: "Flutter,Firebase,Qr code scanner",
    github_url: "https://github.com/JohnM-Kahura/Digital-Receipts",
    demo_url: "https://github.com/JohnM-Kahura/Digital-Receipts#readme",
  },

];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Python-logo-notext.svg/2048px-Python-logo-notext.svg.png",
    name: "Python",
  },
  {
    img: "https://www.djangoproject.com/m/img/logos/django-logo-negative.png",
    name: "Django",
  },
  {
    img: "https://iconape.com/wp-content/files/yb/61798/svg/flutter-logo.svg",
    name: "Flutter",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/javascript.svg",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/react.svg",
    name: "ReactJS",
  },
  {
    img: "https://miro.medium.com/max/595/1*ax2uBqfp963n4PQVqmGplQ.png",
    name: "Spacy",
  },
  {
    img: "https://cdn.dribbble.com/users/528264/screenshots/3140440/media/5f34fd1aa2ebfaf2cd548bafeb021c8f.png?compress=1&resize=400x300&vertical=top",
    name: "FireBase",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/git.svg",
    name: "Git",
  },
  {
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Postgresql_elephant.svg/745px-Postgresql_elephant.svg.png",
    name: "Postgres",
  },
];
